module.exports = __webpack_public_path__ + "static/img/mlyu+-details.076f711.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/mlyu+-details.png
// module id = qICA
// module chunks = 0